import React, { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import AppContext from "../../container/context";
import Form from "../../components/form";

export default function Parametro() {
  const { notification } = useContext(AppContext);
  const [parametros, setParametros] = useState({});

  useEffect(() => {
    carregar();
  }, []);

  const carregar = () => {
    api
      .get("parametros/carregar")
      .then((res) => {
        console.log("res", res);
        setParametros(res);
      })
      .catch((err) => {
        notification("error", "Não foi possível carregar parâmetros");
      });
  };

  const salvar = (params) => {
    const dadosParams = params;
    setParametros(dadosParams);

    api
      .post("parametros/salvar", dadosParams)
      .then((res) => {
        notification("success", "Parâmetros salvos!");
      })
      .catch((err) => {
        notification("error", "Não foi possível salvar parâmetros");
      });
  };

  const fDados = {
    title: "Parâmetros Do Sistema",
    form: {
      urlPortal: {
        label: "URL Portal",
        type: "text",
        value: parametros.urlPortal,
        // space:
      },
      emailHost: {
        label: "Email - Host",
        type: "text",
        value: parametros.emailHost,
        space: 6,
      },
      emailPorta: {
        label: "Email - Porta",
        type: "text",
        value: parametros.emailPorta,
        space: 6,
      },
      emailUsuario: {
        label: "Email - Usuário",
        type: "text",
        value: parametros.emailUsuario,
        space: 6,
      },
      emailSenha: {
        label: "Email - Senha",
        type: "password",
        value: parametros.emailSenha,
        space: 6,
      },
      firebaseHost: {
        label: "Firebase - Host",
        type: "text",
        value: parametros.firebaseHost,
      },
      firebaseChave: {
        label: "Firebase - Chave",
        type: "textarea",
        value: parametros.firebaseChave,
      },
    },

    submit: {
      label: "Salvar",
      action: salvar,
    },
  };

  return (
    <div>
      <Form formData={fDados} />
    </div>
  );
}
